// extracted by mini-css-extract-plugin
export default {"table":"CellStatsPage_table__O4h1b","cellStatsTable":"CellStatsPage_cellStatsTable__kWvN5","cellStats":"CellStatsPage_cellStats__fcmhV"};